import o from "./classes/URLSearchParams.js";
import r from "./classes/FormData.js";
import t from "./classes/Blob.js";
const l = {
  isBrowser: !0,
  classes: {
    URLSearchParams: o,
    FormData: r,
    Blob: t
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
export {
  l as default
};
